export default "__VITE_ASSET__S_h_VL_Q__"